var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2435 4428 c-22 -6 -542 -222 -1155 -481 l-1115 -471 -56 -56 c-126 -125 -126 -315 0 -440 l56 -56 1115 -471 c613 -259 1136 -476 1162 -482 65 -15 183 -14 248 3 62 17 2217 926 2267 957 51 32 110 106 128 160 22 64 22 154 0 218 -18 54 -77 128 -128 160 -50 31 -2205 940 -2267 957 -61 16 -195 17 -255 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4585 2536 l-100 -43 -3 -139 -3 -139 -46 -30 c-124 -80 -147 -267 -48 -383 l37 -42 -36 -42 c-54 -63 -66 -116 -66 -300 0 -244 4 -248 265 -248 265 0 265 0 265 255 0 200 -9 237 -73 303 l-31 32 31 33 c117 120 90 319 -54 408 l-33 20 -2 179 -3 178 -100 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 1932 c0 -267 4 -440 11 -474 20 -95 75 -194 148 -268 59 -59 88 -77 237 -152 290 -145 528 -219 864 -270 116 -18 566 -17 685 1 337 50 588 130 879 278 127 65 162 88 217 143 42 42 77 89 97 131 60 123 62 141 62 606 0 233 -3 423 -6 423 -4 0 -309 -128 -678 -284 -369 -156 -702 -291 -741 -301 -94 -24 -257 -24 -350 0 -38 10 -367 144 -730 298 -363 153 -668 281 -677 284 -17 5 -18 -19 -18 -415z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.a51924a5838705f741ea903963d51311.svg";
export { ForwardRef as ReactComponent };